package features.teams.domain

data class Team(
    val id: String,
    val name: String,
    val ownerId: String,
    val role: String,
    val memberCount: Int,
    val shiftCount: Int,
    val avatar: String? = null,
    val isArchived: Boolean = false,
    val slug: String = "", // URL-friendly identifier for secure routing
    val defaultStartTime: String = "08:00", // Default clock in time
    val defaultEndTime: String = "17:00" // Default clock out time
) {
    fun canBeEditedBy(userId: String): Boolean {
        return ownerId == userId
    }
    
    fun canBeArchivedBy(userId: String): Boolean {
        return ownerId == userId
    }
}
